import React, { forwardRef, useRef, useState, useImperativeHandle } from "react";
import { useTranslation } from "src/context/Translations/context";
import IFiltersActionsPanel, { ActionGroupers, ActionSituation } from "src/pages/Actions/Panel/interface";
import ModalReleaseActionsInDraft from "src/components/ModalReleaseActionsInDraft";
import { IReleaseActionsRef } from "src/components/ModalReleaseActionsInDraft/interface";
import executeQueryListOfActions from "src/pages/Actions/Panel/executeQueryListOfActions";
import { standardErrorMessages } from "src/utils/errors";
import { RCCHookToast } from "react-common-components";

export interface IIniciativeReleaseActionsRef{
    openModalReleaseActions: (iniciativeId: number, iniciativeNome: string, onCallback?: Function) => void;
}

const ModalIniciativeReleaseActions: React.ForwardRefRenderFunction<IIniciativeReleaseActionsRef> = (_, ref) => {
	const { translate } = useTranslation();
	const { addToast } = RCCHookToast();
	const refModalReleaseActions = useRef<IReleaseActionsRef>(null);
    
	// Modal Release Actions
	const [subtitle, setSubtitle] = useState<string | undefined>(undefined);
	const [iniciativeSeleted, setIniciativeSeleted] = useState<number>();
	const onCallbackRelease = useRef<Function | undefined>(undefined);
	
	const openModalReleaseActions = async (iniciativeId: number, iniciativeNome: string, onCallback?: Function) => {
		setIniciativeSeleted(iniciativeId);
		setSubtitle(`${translate("Iniciativa")}: ${iniciativeNome}`);
		onCallbackRelease.current = onCallback;
		
		try{
			const filter = {} as IFiltersActionsPanel;
			filter.situation = ActionSituation.DRAFT;

			const listActions = await executeQueryListOfActions(
				{
					group: ActionGroupers.INICIATIVE,
					origin: "",
					delayed: ""
				}, 
				{
					grouperId: iniciativeId || 0
				}, 
				filter);

			refModalReleaseActions.current?.openModalReleaseActionsInDraft(listActions);

		}catch(err){
			standardErrorMessages(err, translate("Erro ao carregar as ações"), addToast);
		}
	};

	useImperativeHandle(ref, () => ({
		openModalReleaseActions
	}));

	return (
		<>
			<ModalReleaseActionsInDraft
				ref={refModalReleaseActions}
				onCallbackRelease={onCallbackRelease.current}
				subtitle={subtitle || ""}
				relatedTableId={iniciativeSeleted || 0}
				relatedMethodController="Iniciative/ReleaseActions" />
		</>
	);
};

export default forwardRef(ModalIniciativeReleaseActions);

